import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function formSelectValueValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isValid = control.value ? control.value.length > 0 && control.value.some(el => el !== null) : false
    const error: ValidationErrors = { doesntContain: true };
    return isValid ? null : error;
  }
}

export function atLeastOneRequired(controlsConfig: { [key: string]: 'string' | 'number' | 'boolean' | 'object' | undefined }): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    let isValid = false;

    for (const [controlName, expectedType] of Object.entries(controlsConfig)) {
      const control = (formGroup as any).controls[controlName];
      if (control) {
        const value = control.value;

        if (expectedType === 'string' && typeof value === 'string' && value.trim() !== '') {
          isValid = true;
          break;
        }
        if (expectedType === 'number' && typeof value === 'number' && !isNaN(value)) {
          isValid = true;
          break;
        }
        if (expectedType === 'boolean' && typeof value === 'boolean') {
          isValid = true;
          break;
        }
        if (expectedType === 'object' && typeof value === 'object' && value !== null && Object.keys(value).length > 0) {
          isValid = true;
          break;
        }
        if (expectedType === undefined && value !== null && value !== undefined && value !== '') {
          isValid = true;
          break;
        }
      }
    }

    return isValid ? null : { atLeastOneRequired: true };
  };

}
